import { jsx as _jsx } from "react/jsx-runtime";
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import { BasicViewContainer } from './BasicViewContainer';
import { FramedViewContainer } from './FramedViewContainer';
import { useAcq129 } from '../experiments/acq129/acq129Hooks';
import { useTrackGooglePromptUsedPreSignup } from '../google-authentication/google-prompt/googlePromptTracking';
export const ViewContainer = () => {
  useAcq129();
  useTrackGooglePromptUsedPreSignup();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const Container = isInstanceOfSignupEmbedder ? FramedViewContainer : BasicViewContainer;
  return /*#__PURE__*/_jsx(Container, {});
};